import s1 from "../Assets/Images/Image/Portfolio/sample/s1.webp";
import s2 from "../Assets/Images/Image/Portfolio/sample/s2.webp";
import s3 from "../Assets/Images/Image/Portfolio/sample/s3.webp";
import s4 from "../Assets/Images/Image/Portfolio/sample/s4.webp";
import s5 from "../Assets/Images/Image/Portfolio/sample/s5.webp";
import s6 from "../Assets/Images/Image/Portfolio/sample/s6.webp";
import s7 from "../Assets/Images/Image/Portfolio/sample/s7.webp";
import s8 from "../Assets/Images/Image/Portfolio/sample/s8.webp";
import s9 from "../Assets/Images/Image/Portfolio/sample/s9.webp";

const Portfolio_data = [
  {
    _id: 1,
    img: s1,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 2,
    img: s2,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 3,
    img: s3,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 4,
    img: s4,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 5,
    img: s5,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 6,
    img: s6,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 7,
    img: s7,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 8,
    img: s8,
    title: "Webflow point of sale Landing",
  },
  {
    _id: 9,
    img: s9,
    title: "Webflow point of sale Landing",
  },
];

export default Portfolio_data;
